export {default as AuthTemplate} from './TemplateAuth';
export {default as AppTemplate} from './TemplateApp';